import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The kit adds a pill radius to Tailwind. It must participate in radius conflicts
// so a reference tile can override a Button capsule with its own rounded corners.
const twMerge = extendTailwindMerge({ extend: { theme: { radius: ["pill"] } } });

/**
 * The single class-composition helper. Merges conditional classes (clsx) and
 * resolves Tailwind conflicts (tailwind-merge) so later classes win.
 *
 * Used everywhere a className is composed. Primitives are the only place that
 * should pass token utilities (bg-canvas, text-ink-soft, …) through it.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
